
  <section class="page-banner-sec" style="background-image: url(assets/img/blog-page-banner.png)">
    <div class="container">
        <h1 class="page-banner-title">Blogs</h1>
    </div>
  </section>

  <section class="py-5">
    <div class="container">
        <h2 class="font-weight-bold">Recent Posts</h2>
        <div class="row">
            <div class="col-lg-4 col-sm-6" *ngFor="let item of blogList">
                <div class="blog-card fadeUpAnimation">
                    <div class="blog-card-image">
                        <img [src]="item.image">
                    </div>
                    <div class="blog-card-body">
                        <h4>{{item.title}}</h4>
                        <div class="date">{{item.createdAt | date :'fullDate'}}</div>
                        <p>{{item.description.length < 100 ? item.description : item.description.slice(0,100)+'...'}}</p>
                        <a [routerLink]="['/blog-detail',item._id]">Read More</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center">
            <nav aria-label="Page navigation">
                <!-- <ul class="pagination mt-3 justify-content-center">
                  <li class="page-item disabled"><a class="page-link" href="javascript:void(0);"><i class="fa fa-chevron-left"></i></a></li>
                  <li class="page-item active"><a class="page-link" href="javascript:void(0);">1</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0);">2</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0);">3</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0);"><i class="fa fa-chevron-right"></i></a></li>
                </ul> -->
              </nav>
        </div>
    </div>
  </section>


